import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SolutionsOverview from "./SolutionsOverview";
import IndividualSolution from "./IndividualSolution";
import AgentsMerchant from "./AgentsMerchant";
import SaccosInstitutions from "./SaccoInstitutions";
import LocalGovernmentSolution from "./LocalGovernmentInstitution";

const NAV_OFFSET = 72; // TopBar height + a little breathing room

const scrollToSection = (hash: string) => {
  if (!hash) {
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }
  const el = document.querySelector(hash);
  if (el) {
    const top = el.getBoundingClientRect().top + window.scrollY - NAV_OFFSET;
    window.scrollTo({ top, behavior: "smooth" });
  }
};

export default function Solutions() {
  const location = useLocation();

  useEffect(() => {
    // Small delay lets the page paint before scrolling
    const timer = setTimeout(() => {
      scrollToSection(location.hash);
    }, 80);
    return () => clearTimeout(timer);
  }, [location.hash]);

  return (
    <>
      <section id="overview">
        <SolutionsOverview />
      </section>

      <section id="individuals">
        <IndividualSolution />
      </section>

      <section id="agents-merchants">
        <AgentsMerchant />
      </section>

      <section id="saccos-institutions">
        <SaccosInstitutions />
      </section>

      <section id="local-governments">
        <LocalGovernmentSolution />
      </section>
    </>
  );
}
